// Emails types
export const FETCH_ESTIMATIONS_START = "FETCH_ESTIMATIONS_START"
export const FETCH_ESTIMATIONS_SUCCESS = "FETCH_ESTIMATIONS_SUCCESS"
export const FETCH_ESTIMATIONS_ERROR = "FETCH_ESTIMATIONS_ERROR"
export const DELETE_ESTIMATION_START = "DELETE_ESTIMATION_START"
export const DELETE_ESTIMATION_SUCCESS = "DELETE_ESTIMATION_SUCCESS"
export const DELETE_ESTIMATION_ERROR = "DELETE_ESTIMATION_ERROR"
